export enum AllGradesFilterType {
  ActivityDegreesStatusFilter = 1,
  DegreesFilter = 2,
  SemesterListFilter = 3,
  SortTypeListFilter = 4,
  FreeSearch = 5,
}
